// extracted by mini-css-extract-plugin
export default {"doughnutGraph":"OneDrive_doughnutGraph__K+tAV","lineGraph":"OneDrive_lineGraph__Fsc1B","oneDriveLink":"OneDrive_oneDriveLink__mKbk2"};